<!-- eslint-disable max-len -->
<template>
  <modal :styles="{ top: '24px !important' }"
    :minHeight="Infinity" :classes="'modal-terms'" :maxWidth="800" width="100%" :shiftY="0.1" height="auto" adaptive name="terms">
    <div class="modal-header">
      <h1 class="header-title">Termos do Seguro Prestamista</h1>
      <a style="display: flex; margin-left: auto; align-items: center" href="#!" @click="$modal.hide('terms')">
        <XIcon style="color: #0f172a" />
      </a>
    </div>
    <div class="modal-container-terms">
      <h2 class="modal-title">Declaração do Proponente do Seguro</h2>
      <span class="modal-text">Declaro estar de acordo com a presente proposta e condições contratuais e que nada omiti,
        tendo prestado todas as informações completas e verídicas, ficando a Seguradora autorizada a
        utilizar tais informações no amparo e defesa de seus direitos. Estou ciente que de acordo
        com o Artigo 766 do Código Civil Brasileiro, se prestei declarações inexatas ou omiti
        informações e/ou circunstâncias que possam influir na aceitação de proposta ou no cálculo de
        prêmio, o seguro se tornará nulo, perdendo o direito às coberturas. Pelo presente, solicito
        minha inclusão na apólice contratada pelo Estipulante junto à Seguradora, constituindo-o meu
        mandatário, com poderes expressos para representar-me, na forma prevista no Decreto Lei
        73/66 e do Código Civil. Declaro que, ao preencher a presente proposta de adesão, tomei
        conhecimento na íntegra das Condições Contratuais do seguro, incluindo as Condições Gerais,
        estando ciente que: a) A aceitação da proposta de seguro está sujeita à análise do risco. A
        Seguradora, após recebimento da Proposta, terá 15 dias para definir pela aceitação ou recusa
        do risco. O seguro será automaticamente aceito, caso a Seguradora não manifeste por escrito,
        o motivo da recusa no prazo de 15 (quinze) dias, contados da data em que a Proposta for
        protocolizada junto à Seguradora. Este prazo será suspenso, quando a Seguradora solicitar a
        apresentação de novos documentos para análise dos riscos, o que somente poderá ocorrer uma
        única vez, voltando o prazo a correr a partir da data em que se der a entrega da
        documentação. b) Este seguro é por prazo determinado tendo a Seguradora a faculdade de não
        renovar a apólice na data de vencimento, sem devolução dos prêmios pagos nos termos da
        apólice. c) O registro do produto é automático e não representa aprovação ou recomendação
        por parte da Susep. O segurado poderá consultar a situação cadastral do corretor de seguros
        e da sociedade seguradora no sítio eletrônico www.susep.gov.br. d) Este plano utiliza o
        regime financeiro de repartição simples, que é o regime financeiro que fixa a taxa de
        custeio dos benefícios contratados, de modo a produzirem receitas equivalentes aos
        benefícios e despesas geradas no período, não havendo capitalização de reserva em
        decorrência dos prêmios recebidos, portando, não há devolução ou resgate do prêmio ao
        Segurado, Beneficiário ou Estipulante, após a aceitação do seguro pela Seguradora. e) As
        condições contratuais deste produto encontram-se registradas na Susep de acordo com o número
        de processo constante da proposta e poderão ser consultadas no endereço eletrônico
        www.susep.gov.br. f) Conforme estabelecido no Art. 3 da Circular SUSEP 642/21, a renovação
        não automática ou quaisquer outras alterações no contrato de seguro poderão ser realizadas
        por proposta preenchida e assinada pelo proponente, seu representante legal ou corretor de
        seguros. Renovações automáticas poderão ser realizadas seguindo as condições contratuais. O
        estipulante do seguro é remunerado com 61% do Prêmio Líquido, a cada pagamento do seguro, a
        título de pró-labore. O estipulante informa que há contrato de exclusividade com a
        seguradora para a comercialização e oferta deste produto. Declaro que estou ciente sobre os
        termos das condições contratuais desta proposta. Declaro, como Segurado nesta contratação,
        que, na forma da legislação vigente, recebi todas as informações obrigatórias contidas na
        Resolução CNSP nº 382/2020, inclusive quanto à prévia disponibilização das informações
        previstas no art. 4º, § 1º, da referida Resolução. O proponente e/ou seu representante
        devidamente autorizado, reconhece que, ao preencher esta proposta com fornecimento das
        informações nela constante, concorda que os dados pessoais e/ou de saúde serão usados e
         analisados pela SEGURADORA para aceitação ou não do risco,
        e sendo estabelecido o contrato de seguro, esses dados poderão ser usados em modelos
        estatísticos das empresas, bem como para o fim único da execução do contrato de seguro,
        sendo que ditas informações poderão ser compartilhadas com empresas que ajudem no
        cumprimento do contrato de seguro. Os dados do CLIENTE serão guardados com todo zelo e
        cuidado, e mantidos pelo prazo previsto pelo Regulador de Seguros. Central de Atendimento
        Zurich: SAC 0800 284 4848 / Deficiente Auditivo 0800 275 8585 / Ouvidoria 0800 770 1061.
        Zurich Minas Brasil Seguros S/A CNPJ: 17.197.385/0001-21, Código SUSEP: 05495 - Produto
        registrado na SUSEP sob os números: 15414.901073/2014-30 (Prestamista Saldo Devedor - Ramo
        77).</span>
    </div>
  </modal>
</template>

<script>
import { XIcon } from '@vue-hero-icons/outline';

export default {
  name: 'terms-modal',
  components: {
    XIcon,
  },
  methods: {
    showTermsModal() {
      this.$modal.show('terms');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .vm--modal {
  position: fixed !important;
  top: 24px !important;
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
  overflow: visible !important;
  bottom: 0px !important;
}

::v-deep .vm--container {
  min-height: auto !important;
}

.modal-header {
  display: flex;
  position: sticky;
  top: 0;
  padding: 16px 20px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #e2e8f0;
  z-index: 999999999999999999999999999999999999;

  >.header-title {
    color: #0f172a;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
}

.modal-container-terms {
  scroll-behavior: smooth;
  top: 57px;
  bottom: 0;
  padding: 20px;
  height: calc(100% - 105px);
  overflow-y: visible;
  overflow-x: hidden;
  background: white;

  >.modal-title {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
  }

  >.modal-text {
    display: block;
    margin-top: 16px;
    color: #0f172a;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
}

</style>
